import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = ["disabled"]
const _hoisted_2 = { class: "selected-type-label" }
const _hoisted_3 = { class: "contacts-icon" }
const _hoisted_4 = { class: "selected-type-text" }
const _hoisted_5 = { class: "scrollable-item-list" }
const _hoisted_6 = ["id", "onClick"]

import DropDownMenu from '@/shared/components/dropDownMenu/DropDownMenu.vue';
import { ContactType } from '@/features/contacts/models/contactType';
import { onMounted, PropType, ref } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ContactTypePicker',
  props: {
  value: {
    type: String as PropType<ContactType>,
    required: true,
  },
  disabled: {
    type: Boolean,
    default: 'false',
  },
},
  emits: ["updated-type"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const selectedType = ref(ContactType.User);
const active = ref(false);

onMounted(() => (selectedType.value = props.value));

function getContactTypes(): ContactType[] {
  return [ContactType.Lead, ContactType.User];
}

function selectType(type: ContactType) {
  if (props.disabled) {
    return;
  }

  if (selectedType.value !== type) {
    emit('updated-type', type);
  }
  selectedType.value = type;
  active.value = false;
}

function getFormattedType(type: ContactType): string {
  return `${type.charAt(0).toUpperCase()}${type.slice(1)}s`;
}

function setActive(isOpen: boolean) {
  if (props.disabled) {
    return;
  }

  active.value = isOpen;
}

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(DropDownMenu, {
      "drop-down-icon": "none",
      class: "contact-type-dropdown",
      disabled: __props.disabled,
      onOpen: setActive
    }, {
      trigger: _withCtx(() => [
        _createElementVNode("button", {
          class: _normalizeClass(["button", { 'dropdown-active': active.value }]),
          disabled: __props.disabled
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_font_awesome_icon, { icon: "user-friends" })
            ]),
            _createElementVNode("div", _hoisted_4, _toDisplayString(getFormattedType(selectedType.value)), 1)
          ])
        ], 10, _hoisted_1)
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getContactTypes(), (contactType) => {
            return (_openBlock(), _createElementBlock("a", {
              id: 'contact-type-item-' + contactType,
              class: "dropdown-item",
              key: contactType,
              onClick: ($event: any) => (selectType(contactType))
            }, _toDisplayString(getFormattedType(contactType)), 9, _hoisted_6))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["disabled"])
  ]))
}
}

})